import React, {Component} from "react";
import {BILATERAL_CONTROL_PANEL_ROUTE} from "../../../../utils/constants/RoutesConstants";
import BilateralMaturityView from "./BilateralMaturityView";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";
import {MaturityLoanService} from "../../../../service/bilateral/loan/MaturityLoanService";

export default class BilateralMaturityContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService()
        this.maturityLoanService = new MaturityLoanService();
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.getLoanData = this.getLoanData.bind(this);

        this.state = {
            isLoading: false,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanData: [],
            loanCollaterals: [],
        };
    }

    componentDidMount (){
        this.getLoanData();
    }

    getLoanData() {
        this.loading(true)
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.bilateralLoanService.getLoanDetail(loanId, true)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        loanData: [res.data],
                        loanCollaterals: res.data.collateralDetail.collateralDetailList
                    });
                }
                this.loading(false)
            });
    }
    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
            message: message,
        });
    }

    handleAgree() {
        this.loading(true)
        let loanId = this.state.loanData[0].id;
        this.maturityLoanService.matureLoan(loanId)
            .then( res => {
                if (this.validResponse(res)){
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'Se ha avanzado el préstamo exitosamente.',
                    });
                }
                this.loading(false)
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralMaturityView
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            loanData={this.state.loanData}
            loanCollaterals={this.state.loanCollaterals}
            handleReturnButton={this.handleReturnButton}
            handleAgree={this.handleAgree}
        />
    }
};

BilateralMaturityContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};